import { useEffect, useState, useCallback, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import CyberBay from "../../../assets/img/CyberBayFinalBlueLogo.png";
import TevelCyberLogo from "../../../assets/img/TevelCyberFinalBlueLogo.png";
import LoginImage from "../../../assets/img/LoginIllustraion.png";
import UserService from "../../../services/UserService";
import AuthContext from "../../../auth/AuthContext";
import AlertService from "../../../services/AlertService";
import AnswerIcon from "../../../assets/icons/AnswerIcon.svg";

const MFAQ = () => {
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ansIsValid, setAnsIsValid] = useState(true);
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const submitControllerRef = useRef(null);

  // Refs for answers
  const ans1Ref = useRef();
  const ans2Ref = useRef();

  const loadQuestions = useCallback(async () => {
    try {
      const result = await UserService.GetMFAQ(authContext);
      if (result.isSuccess) {
        setQuestions(result.data);
      } else {
        AlertService.error(result.errorMessage);
      }
    } catch (error) {}
  }, [authContext]);

  const validateVerified = useCallback(() => {
    if (authContext.mfaVerified) navigate("/");
  }, [authContext.mfaVerified, navigate]);

  useEffect(() => {
    validateVerified();
    loadQuestions();
  }, [validateVerified, loadQuestions]);



const handleSubmit = async (e) => {
  e.preventDefault();
  setAnsIsValid(true);

  const answers = {
    ans1: ans1Ref.current.value,
    ans2: ans2Ref.current.value,
  };

  if (!answers.ans1 || !answers.ans2) {
    setAnsIsValid(false);
    return;
  }

  if (submitControllerRef.current) {
    submitControllerRef.current.abort();
  }
  const controller = new AbortController();
  submitControllerRef.current = controller;

  setLoading(true);

  try {
    const payload = [
      { questionId: questions[0].id, answer: answers.ans1 },
      { questionId: questions[1].id, answer: answers.ans2 },
    ];

    const result = await UserService.ValidateSQ(
      payload,
      authContext,
      controller.signal
    );

    if (controller.signal.aborted) return;

    if (result.isSuccess) {
      authContext.setMFAVerified(true);
      navigate("/");
    } else {
      AlertService.error(result.errorMessage);
    }
  } catch (error) {
    if (error.name === "AbortError") return;
  } finally {
    if (!controller.signal.aborted) setLoading(false);
  }
};

// Unmount cleanup
useEffect(() => {
  return () => {
    submitControllerRef.current?.abort();
  };
}, []);

  return (
    <div className="container-fluid min-vh-100 d-flex flex-column flex-xl-row p-0">
      <div className="col-xl-6 d-flex flex-column justify-content-center align-items-center p-3 p-lg-5 min-vh-100  ">
        <div className="d-none d-xl-block">
          <img
            src={TevelCyberLogo}
            alt="Company Logo"
            style={{ maxWidth: "217px", marginRight: "220px" }}
            className="img-fluid"
          />
        </div>
        <div className="d-flex flex-column justify-content-center align-items-center flex-grow-1 w-100">
          <div className="d-flex d-xl-none justify-content-between align-items-center gap-5 mt-3 mb-4">
            <img
              src={TevelCyberLogo}
              alt="Tevel Cyber Logo"
              className="img-fluid"
              style={{ width: "140px" }}
            />
            <img
              src={CyberBay}
              alt="Cyber Bay Logo"
              className="img-fluid"
              style={{ width: "120px" }}
            />
          </div>
          <div className="w-100 mb-xl-4" style={{ maxWidth: "440px" }}>
            <h4 className="mb-3  text-center text-xl-start fw-bold">
              Security Questions
            </h4>
            <form onSubmit={handleSubmit}>
              {questions.slice(0, 2).map((question, index) => (
                <div className="mb-3" key={question.id}>
                  <div className="mb-2">
                    <small>Security Question {index + 1}</small>
                    <br />
                    <b>{question.question}</b>
                  </div>
                  <div className="input-group">
                    <span className="input-group-text bg-transparent border-end-0">
                      <img
                        src={AnswerIcon}
                        alt="answer"
                        style={{ color: "#ccc" }}
                        className="fs-5"
                      />
                    </span>
                    <input
                      type="text"
                      className={`form-control border-start-0 custom-input `}
                      placeholder="Enter your answer"
                      style={{ paddingLeft: "5px" }}
                      ref={index === 0 ? ans1Ref : ans2Ref}
                    />
                  </div>
                  {!ansIsValid && (
                    <div className="text-danger mb-3">
                      Please provide an answers
                    </div>
                  )}
                </div>
              ))}
              <div className="d-flex justify-content-between mt-4">
                <button
                  type="button"
                  className="btn text-decoration-none btn-outline custom-input"
                  onClick={() => navigate("/login")}
                  style={{ maxWidth: "180px" }}
                >
                  Back to Login
                </button>
                <button
                  type="submit"
                  className="btn btn-primary px-5 custom-input"
                  disabled={loading}
                  style={{ maxWidth: "180px" }}
                >
                  {loading ? (
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : null}
                  {loading ? "Verifying..." : "Verify"}
                </button>
              </div>
            </form>
          </div>
        </div>
        <footer className="mt-auto text-center w-100">
          <p className="text-muted small mb-0">
            © 2026 Tevel Cyber Corps Pvt. Ltd. All rights reserved - Version 2.2.0
          </p>
        </footer>
      </div>
      <div className="col-xl-6 d-none d-xl-flex flex-column login-bg  min-vh-100 align-items-center justify-content-center  ">
        <div className="p-5 mt-2">
          <img
            src={CyberBay}
            alt="CYBER BAY"
            className="img-fluid mb-4"
            width="130px"
          />
        </div>
        <div className='"d-flex flex-column justify-content-center align-items-center flex-grow-1 w-100 p-xl-5'>
          <img
            src={LoginImage}
            alt="Decorative"
            className="img-fluid loginImg"
            style={{
              maxWidth: "690px",
              maxHeight: "484px",
              marginLeft: "130px",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default MFAQ;
